import { useEventEventCheckIn } from "@crowdcoursing/api/openapi";
import { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";

import { valueOrFallback } from "~utils/sanitizeDto";

import { useDispatch } from "../../hooks";
import { Route } from "../../services/router/Route";
import { successToast } from "../../state/notifications";

const tCheckingIn = "Checking in...";
const tCheckInSuccess = "You have been checked in";

/** @deprecated We are phasing out `components/**` */
export const CheckIn = () => {
  const { eventId } = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { mutateAsync } = useEventEventCheckIn();
  useEffect(() => {
    mutateAsync({
      pathParams: {
        eventId: valueOrFallback(eventId, "MISSING_EVENT_ID", "(CheckIn) Missing event id from url params"),
      },
    }).then(() => {
      navigate(
        Route.eventView({
          eventId: valueOrFallback(eventId, "MISSING_EVENT_ID", "(CheckIn) Missing event id from url params"),
        }),
      );
      dispatch(successToast({ message: tCheckInSuccess }));
    });
  }, [eventId, navigate, dispatch, mutateAsync]);

  return <>{tCheckingIn}</>;
};
